import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AuthService } from "../../services/auth/auth.service";
export let AuthGuard = class AuthGuard {
    authService;
    $iAuthenticated;
    isAuthenticated;
    constructor(authService) {
        this.authService = authService;
        this.$iAuthenticated = authService.$isAuthenticated;
        this.$iAuthenticated.subscribe(next => this.isAuthenticated = next);
    }
    canActivate(route, state) {
        return this.handleActivation();
    }
    canActivateChild(childRoute, state) {
        return this.handleActivation();
    }
    handleActivation() {
        if (this.isAuthenticated) {
            return true;
        }
        else {
            this.authService.authenticate().then(r => {
            });
            return false;
        }
    }
    static ctorParameters = () => [
        { type: AuthService }
    ];
};
AuthGuard = __decorate([
    Injectable({
        providedIn: "root"
    })
], AuthGuard);
